export default __webpack_public_path__ + "static/media/ListingProposal.bebba231.svg";